import { StyledWrapper } from './style';

import type React from 'react';

interface Props {
  className?: string;
}

export const GradientScale: React.FC<Props> = (props) => (
  <StyledWrapper {...props}>
    <div className="bar" />
    <div className="labels">
      <span>Niedrig</span>
      <span>Hoch</span>
    </div>
  </StyledWrapper>
);
